import React, { useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import { actionCreators } from "../redux/sagas/utilization";
import MultiSelectDropdown from "../../../components/multiSelectDropdown/multiSelectDropdown";
import { USER_ACCESS } from "../constants";

export const LocationsAverageFilter = () => {
  const dispatch = useDispatch();

  const average = useSelector((state) => state.utilization.average);
  const selectedSubAverageFilterOptions = useSelector(
    (state) => state.utilization.selectedSubAverageFilterOptions
  );
  const selectedAverageLocations = useSelector(
    (state) => state.utilization.selectedAverageLocations
  );

  const availableLocations = useMemo(
    () => selectedAverageLocations,
    [selectedSubAverageFilterOptions]
  );

  if (average !== USER_ACCESS || !availableLocations.length) return null;

  return (
    <div className="select-box" style={{ width: "150px" }}>
      <p className="offers-title">Locations (Average)</p>
      <MultiSelectDropdown
        options={availableLocations}
        selectedFilters={selectedAverageLocations}
        onSelectChange={(data) => dispatch(actionCreators.setAverageLocations(data))}
        enableOnly
        numberDisplayed={0}
        includeSelectAll
        haveOnSelectChange
      />
    </div>
  );
};
